import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "2px #000",
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};
const ModalAlert = (props) => {
  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.setOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <p className="text-center text-base font-bold text-defaultColor">{props.text}</p>
        </Box>

      </Modal>
    </div>
  );
};

export default ModalAlert;
